import React from 'react';

import { DataFetchProvider } from '@betterment/js-runtime';
import { SentryErrorBoundary } from '@betterment/shared-components';
import { StyleClosetThemeProvider, ThemeName } from '@betterment/style-closet-react';
import { Controller } from '@hotwired/stimulus';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import appShell from '../AppShell';
import { FullPageLoader } from '../components/FullPageLoader';

export default class extends Controller {
  connect() {
    // @ts-expect-error TS2322 violates strict null checks
    const App = Sentry.withProfiler(this.app, { name: this.name });

    if (App) {
      const root = createRoot(this.element);
      root.render(
        <SentryErrorBoundary>
          <React.Suspense fallback={this.suspenseFallback}>
            <StyleClosetThemeProvider theme={this.theme}>
              <DataFetchProvider>
                <App {...this.initialProps} />
              </DataFetchProvider>
            </StyleClosetThemeProvider>
          </React.Suspense>
        </SentryErrorBoundary>
      );
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Could not resolve app with name: '${this.name}'`);
    }
  }

  get app() {
    // @ts-expect-error TS2345 violates strict null checks
    return appShell.getApp(this.name);
  }

  get name() {
    return this.data.get('name');
  }

  get suspenseFallback() {
    let fallback = <FullPageLoader />;
    if (this.initialProps?.suspenseFallback === false) {
      // @ts-expect-error TS2322 violates strict null checks
      fallback = null;
    }
    return fallback;
  }

  get theme() {
    return (document.querySelector<HTMLMetaElement>('meta[name="theme"]')?.content || 'default') as ThemeName;
  }

  get initialProps() {
    return JSON.parse(this.data.get('initial-props') || '{}') as Record<string, unknown>;
  }
}
